<div *ngIf="loading; else loaded">Loading...</div>

<ng-template #loaded>
  <div *ngIf="departmentAudits && departmentAudits.length > 0; else noAudits">
    <sd-portal-audit-detail-list
      (nextPage)="onNextPage()"
      [audits]="departmentAudits"
    ></sd-portal-audit-detail-list>
  </div>
  <ng-template #noAudits> No Department audits </ng-template>
</ng-template>
